import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Dropdown } from "@lockerpm/design";
import { CaretDownOutlined } from "@ant-design/icons";
import global from "../../config/global";

const Sort = (props) => {
  const {
    loading = false,
    params = {},
    setParams = () => {},
    className = ""
  } = props;

  const { t } = useTranslation();
  const locale = useSelector((state) => state.system.locale);

  const selectedSortOption = useMemo(() => {
    return global.constants.SORT_OPTIONS.find(
      (o) => o.orderField === params.orderField && o.orderDirection === params.orderDirection
    );
  }, [params.orderField, params.orderDirection]);

  const sortMenus = useMemo(() => {
    return global.constants.SORT_OPTIONS.map((o) => ({
      key: o.key,
      label: (
        <p className={o.key === selectedSortOption?.key ? 'text-primary' : ''}>
          {t(o.label)}
        </p>
      ),
      onClick: () =>
        setParams({
          ...params,
          orderField: o.orderField,
          orderDirection: o.orderDirection,
        }),
    }));
  }, [selectedSortOption, params, locale]);

  return (
    <Dropdown.Button
      className={`sort-dropdown ${className}`}
      icon={<CaretDownOutlined />}
      trigger={['click']}
      disabled={loading}
      menu={{
        items: sortMenus,
        selectedKeys: [],
      }}
    >
      {t('sort_options.sort_by')}
    </Dropdown.Button>
  );
};

export default Sort;
